import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import * as env from "shared/env";

export const styles = (theme: Theme) => {
	return {
		label: {
			textTransform: "none" as const,
			fontSize: 13,
			fontWeight: "bold",
		},
		text: {
			paddingLeft: 5,
		},
		tagChip: {
			margin: 2,
		},
		autoSuggestSelect: {
			"Select__menu-list": {
				maxHeight: 12
			}
		},
		dividerTop: {
			margin: 5,
		},
		dividerBottom: {
			margin: 120,
		},
		alignItemTop: {
			alignSelf: "flex-start",
		}
	} satisfies Record<string, CSSObject>;
};

